import { FC } from "react";
import { useUrlState } from "utils";
import { TableBodyComponent } from "./table-body";
import { TableEmptyComponent } from "./table-empty";
import { TableFooterComponent } from "./table-footer";
import { TableGridBodyComponent } from "./table-grid-body";
import { TableHeaderComponent } from "./table-header";

interface TableComponentProps<TData = any> {
  title: string;
  data: {
    rows: TData[];
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
  };
  loading?: boolean;
  isRefetching?: boolean;
  renderColumns?: FC<TData>;
  renderItem?: FC<TData>;
  renderGridItem?: FC<TData>;
  renderFilter?: FC<{
    filterOpen: boolean;
    setFilterOpen: (val: boolean) => void;
  }>;
  renderExport?: FC<{
    exportOpen: boolean;
    setExportOpen: (val: boolean) => void;
  }>;
  renderLoader?: FC;
  renderSearchOption?: FC;
  renderGridLoader?: FC;
  renderHeaderItems?: FC;
  refetch: () => void;
  hasSearch?: boolean;
  onSearchSubmit?: (search: string, searchField: string) => void;
  defaultSearchField?: string;
  searchOptions?: { label: string; value: string }[];
  defaultView?: "grid" | "list";
}

export const TableComponent: FC<TableComponentProps> = ({
  isRefetching,
  defaultView,
  title,
  data,
  loading,
  renderGridLoader,
  renderColumns,
  renderItem,
  renderFilter,
  renderGridItem,
  renderExport,
  refetch,
  renderLoader,
  renderHeaderItems,
  onSearchSubmit,
  hasSearch,
  searchOptions,
  defaultSearchField,
}) => {
  const [viewType] = useUrlState("view-type");
  const hasGridMode = !!renderGridItem;
  return (
    <div className="space-y-6 flex-1 flex flex-col overflow-y-hidden min-w-full">
      <div className="px-4 sm:px-6">
        <TableHeaderComponent
          title={title}
          renderFilter={renderFilter}
          searchOptions={searchOptions}
          renderExport={renderExport}
          gridable={hasGridMode}
          refetch={refetch}
          renderHeaderItems={renderHeaderItems}
          hasSearch={hasSearch}
          defaultSearchField={defaultSearchField}
          loading={isRefetching}
          defaultView={defaultView}
          onSearchSubmit={onSearchSubmit}
        />
      </div>
      {!loading && (data?.rows?.length || 0) === 0 ? (
        <TableEmptyComponent />
      ) : (
        <>
          {viewType === "grid" && hasGridMode ? (
            <TableGridBodyComponent
              data={data}
              loading={loading}
              renderLoader={renderGridLoader}
              renderItem={renderGridItem}
            />
          ) : (
            <TableBodyComponent
              data={data}
              loading={loading}
              renderColumns={renderColumns}
              renderLoader={renderLoader}
              renderItem={renderItem}
            />
          )}

          <div className="px-4 sm:px-6">
            <TableFooterComponent data={data} />
          </div>
        </>
      )}
    </div>
  );
};
